// Which DC an embed actually renders. `resolver` returns null for an inactive
// target; falling back to `storedId` there would resurrect it on the canvas.
export function embeddedComponentId(storedId, resolver) {
  const id = Number(storedId);
  if (!Number.isFinite(id) || id === 0) {
    return null;
  }
  if (typeof resolver !== "function") {
    return id;
  }

  const resolved = resolver(id);
  if (resolved === null || resolved === undefined) {
    return null;
  }
  const resolvedId = Number(resolved);
  return Number.isFinite(resolvedId) && resolvedId !== 0 ? resolvedId : id;
}
